import { render } from "./CollectionDetailedSearchMaps.vue?vue&type=template&id=2b55e270&scoped=true&ts=true"
import script from "./CollectionDetailedSearchMaps.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchMaps.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchMaps.vue?vue&type=style&index=0&id=2b55e270&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b55e270"]])

export default __exports__